// extracted by mini-css-extract-plugin
module.exports =  {"fieldset":"Fieldset-module__fieldset___gpQU6","legend":"Fieldset-module__legend___VEBbV","fieldset-content":"Fieldset-module__fieldset-content___DhEA4"};